import NetworkRequestsService from 'external-services/network-requests-service/index';

const NS = 'BookingDiagnosticService';
const RETRY_DELAY_MS = 3000;

class BookingDiagnosticService {
  private readonly api = NetworkRequestsService.getNewAPIAxiosInstance(true);

  private async send(payload: object): Promise<void> {
    const url = window.config.ingestUrl;
    if (!url) return;
    try {
      await this.api.post(url, payload);
    } catch {
      await new Promise((resolve) => setTimeout(resolve, RETRY_DELAY_MS));
      try {
        await this.api.post(url, payload);
      } catch (err) {
        console.warn(NS, 'Failed to send diagnostic log after retry', err);
      }
    }
  }

  public reportUnexpectedDateChange(payload: object): void {
    this.send(payload);
  }
}

const instance = new BookingDiagnosticService();
export default instance as BookingDiagnosticService;
